<template>
  <div>
    <ViewTemplateWithTable :panel="panel" :templateList="templateList" :actions="actions" :propsParam="propsParam">
      <div slot="content-buttons">
        <Button _key="btnRentOperationalCreate" title="Locação" classIcon="fas fa-plus-circle" type="primary"
          size="small" eventName="rentOperationalCreate" :clicked="create" />
      </div>
    </ViewTemplateWithTable>
    <PrintPreview v-if="printRent" module="Operational" :rentId="id" :canModifyDocument="false"
      :onHideModal="closeModal" />
  </div>
</template>

<script>

import ViewTemplateWithTable from "@nixweb/nixloc-ui/src/component/template/ViewTemplateWithTable.vue";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import PrintPreview from '../../../components/modules/adm/document/PrintPreview.vue'

import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "RentOperationalListView",
  components: {
    ViewTemplateWithTable,
    Button,
    PrintPreview
  },
  data() {
    return {
      id: "",
      printRent: false,
      panel: {
        module: "Operacional",
        title: "Locação",
        showFilter: true,
        showSearch: true,
        showButtons: true,
      },
      templateList: {
        urlGetApi: "/api/v1/operational/rent/get-all",
        urlDeleteAllApi: "/api/v1/operational/rent/delete",
        showChecks: true,
        headerTable: [
          {
            title: "",
            field: "step",
            type: "html",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            styleBody: "width: 30px;",
          },
          {
            title: "Número/Data",
            field: "numberAndDate",
            type: "text",
            iconSearch: true,
          },
          {
            field: "fullName",
            fieldSecond: "identification",
            title: "Nome",
            type: "link",
            eventName: "rentOperationalUpdate",
            iconSearch: true,
          },
          {
            field: "deliveryDateHourHtml",
            fieldSecond: "startDateHourHtml",
            title: "Saída e Início",
            type: "html",
            classCssTitle: "text-center",
            classCssBody: "text-center",
          },
          {
            title: "Fim e Retorno",
            field: "endDateHourHtml",
            fieldSecond: "devolutionDateHourHtml",
            type: "html",
            classCssTitle: "text-center",
            classCssBody: "text-center",
          },
          {
            field: "statusRentalName",
            title: "Status",
            type: "class",
            fieldComparison: "statusRentalName",
            classCssTitle: "text-center",
            classCssBody: [
              {
                classCss: "text-center badge badge-info",
                fieldComparison: "Orçamento",
              },
              {
                classCss: "text-center badge badge-success",
                fieldComparison: "Aprovada",
              },
              {
                classCss: "text-center badge badge-danger",
                fieldComparison: "Reprovada",
              },
              {
                classCss: "text-center badge badge-primary",
                fieldComparison: "Finalizada",
              },
            ],
          },
          {
            type: "button",
            typeButton: "default",
            styleBody: "width: 24px;",
            button: {
              classIcon: "fa-light fa-share-nodes",
              type: "info",
              size: "small",
              eventName: "printRent",
            },
          },
        ],
      },
      actions: [
        { type: "delete", title: "Remover", description: "Remover", url: "/api/v1/operational/rent/delete", method: "delete", method: "delete", },
      ],
      propsParam: {
        showAll: false
      },
      status: "",
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
  },
  methods: {
    ...mapMutations("generic", ["openModal", "hideModal", "removeLoading"]),
    ...mapActions("generic", ["deleteAllApi"]),
    create() {
      let self = this;
      setTimeout(function () {
        self.$router.push({
          name: "rentOperationalCreate",
        });
        self.removeLoading(["btnRentOperationalCreate"]);
      }, 200);
    },
    closeModal() {
      this.printRent = false;
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "printRent") {
          this.id = event.data.rentId;
          this.printRent = true;
        }

        if (event.name == "rentOperationalUpdate") {
          this.$router.push({
            name: "rentOperationalUpdate",
            params: { id: event.data.rentId, periodRentId: event.data.periodRentId }
          });
          this.removeLoading(["btnRentOperationalCreate"]);
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
.badge-default {
  background-color: #eeeeee;
  font-size: 13px !important;
  border-radius: 50px !important;
}

.div-tag {
  margin-bottom: 10px;
}

.rent-progress {
  color: #4bb4e2;
}

.rent-accepted {
  color: #38A169;
}

.rent-rejected {
  color: #FF5454;
}

.rent-icon-close {
  color: red;
}
</style>